// extracted by mini-css-extract-plugin
export var chevron = "_37-2";
export var chevronCollapsed = "_37-3";
export var collapsibleHeader = "_37-1";
export var container = "_37-0";